module.exports = __webpack_public_path__ + "static/media/wardrobe-open2.aab0f7db.jpg";